import React from 'react';
import { useParams } from 'react-router-dom';
import AgentTripsContainer from './agent-trips-container';

const InfiniteListAgentTripMatches = () => {
  const { agentId } = useParams();

  return <AgentTripsContainer agentId={agentId} />;
};

export default InfiniteListAgentTripMatches;
